import { createFileRoute } from "@tanstack/react-router";
import { AgentWorkflowPage } from "@/components/agent-cli-pages";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/agent/build-content-calendar";
export const Route = createFileRoute(path)({
	component: () => <AgentWorkflowPage slug="build-content-calendar" />,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "Build a Content Calendar with an AI Agent",
			description:
				"Turn goals, channels, assets, and review capacity into a platform-native social content calendar with AgentReacher.",
		}),
});
